import styled from "styled-components";
import { Content } from "@radix-ui/react-dialog";
import { zIndex } from "../../../styles/constants";
import { elevation03, shade950 } from "../../../styles/tokens";

// TEXT

// STYLES
export const ModalWrapper = styled(Content)<{
  $width?: string;
  $height?: string;
}>`
  top: 50%;
  left: 50%;
  z-index: ${zIndex.surface};
  width: ${({ $width }) => $width ?? "30rem"};
  max-width: calc(100vw - 2rem);
  ${({ $height }) => $height && `height: ${$height};`}
  position: fixed;
  padding: 0 0 1.5rem;
  translate: -50% -50%;

  transition:
    width 0.3s ease,
    height 0.3s ease;
  box-shadow: ${elevation03};
  background-color: ${shade950};
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
